import React from 'react';
import { Col } from 'react-bootstrap';

import BlockWrapper from '../../../components/blocks/BlockWrapper';
import GenericBlock from '../../../components/blocks/GenericBlock';
import IconBlock from '../../../components/blocks/IconBlock';
import YoutubeVideoImage from "../../../components/YoutubeVideoImage";

export default class Technology extends React.Component {

    constructor(props) {
        super(props);

        this.title = 'GameTraining Technology';
    }

    render() {
        return (
            <BlockWrapper id="technology">
                <IconBlock className="hidden-xs hidden-sm" icon="dashboard">
                    <h3>{this.title}</h3>
                </IconBlock>

                <GenericBlock>
                    <Col md={6} sm={12} xs={12}>
                        <h4>{this.title}</h4>
                        <p>
                            For over 20 years, the people at TROI Studio combine strategy consulting, expertise in training and technological development. TROI content is distributed through unique platforms reaching tens of thousands of employees in 12 languages in 160 countries.
                        </p>

                        <h4>What clients say</h4>
                        <p>
                            <i>"The technical developments in online training combined with the possibilities of video as a knowledge document give us interesting opportunities. TROI is an excellent thinking partner and enables us to deliver our digital plans."</i>
                        </p>
                        <p className="text-right"><i>Executive Learning and Development Officer</i></p>
                    </Col>

                    <Col md={6} sm={12} xs={12}>
                        <h4>Check out the video</h4>
                        <YoutubeVideoImage videoId="SsVU4Ah8klU" />
                    </Col>
                </GenericBlock>
            </BlockWrapper>
       );
    }
}



// WEBPACK FOOTER //
// ./src/pages/parts/companies/Technology.js